import moment from 'moment-timezone'

let staticAvatar = ''

export default {
  isAccountActive: (state) => {
    // return !(_.isEmpty(state.companyId) || _.isEmpty(state.postId))
    return !_.isEmpty(state.profile) && !_.isEmpty(state.accountId)
  },

  accountAvatar: (state) => (width) => {
    staticAvatar = staticAvatar ? staticAvatar : "/static/images/user_default.png"
      //('https://randomuser.me/api/portraits/'  + (Math.floor(Math.random() * 2) ? 'men' : 'women') + '/' + String(Math.floor(Math.random() * 99) + 1) + '.jpg')

    let avatar = staticAvatar
    if (state.profile.image) {
      if (typeof state.profile.image === 'string') {
        let src = state.profile.image
        if( state.profile.image.indexOf('base64')<0 && state.profile.image.indexOf('http')<0){
          src = `/disk/d/preview/resize/${width}x${width}/${state.profile.image}`
        }
        avatar = src
      } else if (Array.isArray(state.profile.image) && state.profile.image[0]) {
        let src = state.profile.image[0]
        if( state.profile.image[0].indexOf('base64')<0 && state.profile.image[0].indexOf('http')<0){
          src = `/disk/d/preview/resize/${width}x${width}/${state.profile.image[0]}`
        }
        avatar = src
      }
    }
    return avatar
  },

  accountFullName: (state) => {
    const nameDivider = ' '
    let fullName = ''

    // First Name
    fullName = state.profile.first_name ? state.profile.first_name : ''

    // Middle name
    fullName = fullName + (fullName ? nameDivider : '') + (state.profile.mid_name ? state.profile.mid_name : '')

    // Last name
    fullName = fullName + (fullName ? nameDivider : '') + (state.profile.last_name ? state.profile.last_name : '')

    return fullName ? fullName : "Имя не указано"
  },

  userFullName: (state, getters, rootState, rootGetters) => {
    const nameDivider = ' '
    let fullName = ''

    let hasPostContext = rootState.app.layout.hasPostContext
    
    if (hasPostContext) {
      // Get name from Anketa data

      fullName = state.anketa && state.anketa.fullname ? state.anketa.fullname.trim() : ''
    } else {
      // Get name from account data.

      // First Name
      fullName = state.profile.first_name ? state.profile.first_name.trim() : ''
      // Middle name
      fullName = fullName + (fullName ? nameDivider : '') + (state.profile.mid_name ? state.profile.mid_name.trim() : '')
      // Last name
      fullName = fullName + (fullName ? nameDivider : '') + (state.profile.last_name ? state.profile.last_name .trim(): '')
    }

    return fullName ? fullName : "Имя не указано"
  },
  
  accountId: (state) => {
    return state.profile.uuid
  },
  
  accountEmail: (state) => {
    return state.profile.email
  },

  accountPhone: (state) => {
    return state.profile.phone
  },

  accountTimeZone: (state) => {
    // Intl.DateTimeFormat().resolvedOptions().timeZone
    // NOTE: if profile has no timezone return default
    return state.profile.timezone ? state.profile.timezone : moment.tz.guess()
  },

  getLogoStyle: (state, getters, rootState) => {
    // console.log(rootState)
    let logoStyle = state.defaultLogo
    let hasPostContext = rootState.app.layout.hasPostContext
    
    if (hasPostContext) {
      logoStyle = Object.assign({}, logoStyle, {
        fontSize: state.logo.size ? state.logo.size : state.defaultLogo.fontSize,
        fontStyle: state.logo.italic ? 'italic' : 'normal',
        fontWeight: state.logo.bold ? 'bold' : 'normal',
        fontFamily: state.logo.font ? state.logo.font : state.defaultLogo.fontFamily,
        color: state.logo.color ? state.logo.color : state.defaultLogo.color,
        backgroundColor: state.logo.background ? state.logo.background : state.defaultLogo.backgroundColor
      })

      // Clear all backgrounds style in case of IMAGE logo.
      if (state.logo.image_url) {
        logoStyle.background = undefined
        logoStyle.backgroundColor = undefined
      }
    } else {
      // TODO - this getter return LOGO style, not text
      // logoStyle.text = undefined
    }

    return logoStyle
  },
  
  getPostId: (state) => {
    return state.postId
  },
  
  getCompanyId: (state) => {
    return state.companyId
  },
  
  getCompanies: (state) => {
    return state.companies
  },
  
  getAuthTokens: (state) => {
    return state.auth_tokens
  },
  
  isRefreshing:(state) => {
    return state.isTokenRefreshing
  },
  
  refreshingCall:(state) => {
    return state.refreshingCall
  },
  
  getCompanyById: (state) => (id) => {
    return state.companies.find(_company => _company.id == id)
  },
  
  getCompany: (state) => () => {
    return state.companies.find(_company => _company.id == state.companyId)
  },
  
  themes: state => state.themes,
  
  selectedTheme: (state) => {
    let result = state.themes.find( item => item.id === '00000000-0000-0000-0000-000000000001') || state.themes[0];
    state.themes.some( item => {
      if(item.selected === true){
        result = item;
        return true;
      }
    })
    return result
  },
  
  getCompanyByPostID: (state) => (postId) => {
    let company = state.companies.find(_company => {
      return (_company.posts || []).some(_post => {
        if (_post.id == postId) {
          company = _company
          return true
        }
        return false
      })
    })
    return company
  },

  getCompanyDefaultPostId: (state) => (companyId) => {
    let company = state.companies.find(_company => _company.id == companyId)
    // TODO: replace getting first company post with other logic.
    let postId = company && Array.isArray(company.posts) && company.posts[0]
      ? company.posts[0].id
      : null
    return postId
  },

  //
  // Anketa
  //

  getCompanyAnketaID: (state) => (companyId) => {
    let company = state.companies.find(_company => _company.id == companyId)
    let anketaId = company && Array.isArray(company.posts) && company.posts[0]
      ? company.posts[0].form_id
      : null

    return anketaId
  },

  //
  // Post
  //

  getPostsByCompanyId: (state) => (id) => {
    let company = state.companies.find(_company => _company.id == id)
    // TODO: check data format!
    return company ? company.posts : []
  },
  getPosts: (state) => () => {
    let company = state.companies.find(_company => _company.id == state.companyId)
    // console.log("Current company posts list:")
    // console.log(company.posts)    // TODO: check data format!
    return company ? company.posts : []
  },
  getPost: (state) => () => {
    let post = null
    if (state.postId) {
      let company = state.companies.find(_company => _company.id == state.companyId)
      let posts = company ? company.posts : []
      post = posts.find(_post => _post.id == state.postId)
    }
    return post
  },
  getPostById: (state) => (id) => {
    let post = null
    if (id) {
      let company = state.companies.find(_company => _company.id == state.companyId)
      let posts = company ? company.posts : []
      post = posts.find(_post => _post.id == id)
    }
    return post
  },
  
  
}



// WEBPACK FOOTER //
// ./src/apps/account/store/common/getters.js